import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import leaf from "../../Assets/Projects/Screenshot (97).png";
import chatify from "../../Assets/Projects/Screenshot (95).png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few Projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Tiktok Usename Checker"
              description="I created a Tiktok username checker using node.js and javascript using the request, Chalk, ProxyAgent, Prompt, UserAgent, fs, Proxies, usernames and config moidules. 
              How it works is that the Bot goes to the Tiktok signup page and rapidly checks usernames you entered in the Usernames.txt file."
              link="https://github.com/x1comp/TikTok-username-checker"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Nano7z website"
              description="This is an ecommerce website I made for a client using the the React framework in javascript. This has a backend feature where the website communicates with the discord api to send valid discord server invites. I created the UI using adobe XD and lightroom. The UI is very minimalistic."
              link="https://x1comp.github.io/Nano7z/"
            />
          </Col>

         
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
